import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["predict-marathon-time"]!;

export function Body() {
  return (
    <>
      <p>
        Many runners use a 10K or a half marathon to work out what they can run in a marathon.
        The most common formula works well for shorter races, but a study of more than 2,000
        recreational runners showed that it is often too optimistic for the marathon.
      </p>

      <h2>The formula</h2>
      <p>
        In 1981, the engineer Peter Riegel described how race time grows a little faster than
        distance. His formula multiplies your time by the ratio between the distances raised to
        the power of 1.06. A runner with a 50-minute 10K gets a predicted half marathon of about
        1:50:20 and a marathon of about 3:50.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers in New York collected race results and training information from 2,303
        recreational runners through an online survey. They tested how well the formula
        predicted each runner's actual times, and built new models from information a
        recreational runner normally has.
      </p>

      <h2>What they found</h2>
      <p>
        The formula was accurate for races up to the half marathon. For the marathon, it
        predicted times that were too fast: for half of the runners, at least 10 minutes too
        fast. A model based on one earlier race and information about the runner did clearly
        better, and a model based on two earlier races did better still.
      </p>
      <p>
        Weekly mileage and interval training were linked to faster times at all distances,
        while tempo runs were more strongly linked to the shorter races.
      </p>

      <h2>What it means for you</h2>
      <p>
        A 10K tells you a lot about your 10K and your half marathon. It tells you less about
        the marathon, because the marathon also tests how well you hold up after two or three
        hours. If you start a marathon at a pace calculated from a short race alone, there is a
        real risk of slowing down badly in the second half.
      </p>
      <p>
        A recent half marathon is a better guide than a 10K. Your long runs and weekly mileage
        also say a lot about what you can hold for 42 km.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The data came from a survey, so results and training were reported by the runners
        themselves. The models are built on runners who chose to answer, not a random sample.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training uses this formula to estimate race times from your own race or test. The
        estimate is a starting point, not a promise. For the marathon, test the pace on your long
        runs before you decide how fast to start.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Riegel (1981), Athletic records and human endurance.{" "}
          <a href="https://pubmed.ncbi.nlm.nih.gov/7235349/">American Scientist</a>.
        </li>
        <li>
          Vickers & Vertosick (2016), An empirical study of race times in recreational endurance
          runners.{" "}
          <a href="https://doi.org/10.1186/s13102-016-0052-y">BMC Sports Science, Medicine and Rehabilitation</a>.
        </li>
      </ul>
    </>
  );
}
